import React from "react";
import { ArrowDropDownIcon } from "./icons";

// Campo de texto com label flutuante, no lugar do TextField do MUI. CSS em
// styles/controls.css.
//
// - `inputComponent`: troca o <input> por um dos formatadores de
//   NumberInput.js (celular, CPF, CEP, dinheiro...). Recebe value, onChange e
//   os atributos do input, e o `inputRef` pelo ref.
// - `select`: vira um <select> nativo, com as <option> em `children`.
// - `inputProps`: atributos extras direto no <input> (autoComplete, maxLength,
//   inputMode, name...).
export default function TextInput({
  label,
  value,
  onChange,
  error = false,
  helperText,
  required = false,
  disabled = false,
  readOnly = false,
  autoFocus = false,
  type = "text",
  select = false,
  children,
  inputComponent: InputComponent,
  inputProps,
  inputRef,
  endAdornment,
  className,
  style,
  id: idProp,
}) {
  const autoId = React.useId();
  const id = idProp || autoId;
  const helperId = helperText ? `${id}-helper` : undefined;

  // O valor também decide se a label sobe: o :placeholder-shown do CSS não
  // cobre o <select>, e o formatador pode exibir texto diferente do valor.
  const filled = value !== undefined && value !== null && value !== "";

  const classes = ["text-input"];
  if (filled) classes.push("text-input--filled");
  if (error) classes.push("text-input--error");
  if (disabled) classes.push("text-input--disabled");
  if (className) classes.push(className);

  const fieldProps = {
    id,
    className: "text-input__field",
    value: value ?? "",
    onChange,
    required,
    disabled,
    readOnly,
    autoFocus,
    "aria-invalid": error || undefined,
    "aria-describedby": helperId,
    ...inputProps,
  };

  let field;
  if (select) {
    field = (
      <select {...fieldProps} ref={inputRef}>
        {children}
      </select>
    );
  } else if (InputComponent) {
    field = (
      <InputComponent
        type={type}
        {...fieldProps}
        placeholder=" "
        ref={inputRef}
      />
    );
  } else {
    field = (
      <input type={type} {...fieldProps} placeholder=" " ref={inputRef} />
    );
  }

  return (
    <div className={classes.join(" ")} style={style}>
      <div className="text-input__control">
        {field}
        {label && (
          <label htmlFor={id} className="text-input__label">
            {label}
            {required && <span aria-hidden="true"> *</span>}
          </label>
        )}
        {select && <ArrowDropDownIcon className="text-input__select-arrow" />}
        {endAdornment && (
          <span className="text-input__adornment">{endAdornment}</span>
        )}
      </div>
      {helperText && (
        <p id={helperId} className="text-input__helper">
          {helperText}
        </p>
      )}
    </div>
  );
}
